import React from "react";
import "./OrderDetailsModal.css";

const OrderDetailsModal = ({ order, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Order Details (ID: {order.order_id})</h3>
        <p>Date: {new Date(order.timestamp).toLocaleString()}</p>
        <table>
          <thead>
            <tr>
              <th>Brand Name</th>
              <th>Packing</th>
              <th>Quantity</th>
              <th>Company</th>
            </tr>
          </thead>
          <tbody>
            {order.items.map((item) => (
              <tr key={item.item_id}>
                <td>{item.brandName}</td>
                <td>{item.packing}</td>
                <td>{item.quantity}</td>
                <td>{item.company}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default OrderDetailsModal;
